export default {"src":"/_next/static/media/atom.d0db5e70.svg","height":32,"width":106,"blurWidth":0,"blurHeight":0};